
import { ApiClient } from "./client";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

// Update the interface to make all fields required to match how it's being used
export interface ContactFormData {
  name: string;
  email: string;
  subject: string;
  message: string;
}

class ContactApi extends ApiClient {
  /**
   * Submit a contact form
   */
  async submitContactForm(formData: ContactFormData): Promise<{ success: boolean }> {
    try {
      console.log("Submitting contact form via Supabase Edge Function");
      
      const { data, error } = await supabase.functions.invoke('contact-form', {
        body: formData,
      });
      
      if (error) {
        console.error("Edge function error:", error);
        this.handleError(error, "Failed to submit contact form");
        return { success: false };
      }
      
      console.log("Form submission response:", data);
      return { success: true };
    } catch (error) {
      this.handleError(error, "Failed to submit contact form");
      return { success: false };
    }
  }

  /**
   * Send notification for contact form submission
   */
  async sendContactNotification(formData: ContactFormData): Promise<{ success: boolean }> {
    try {
      console.log("Sending notification via Supabase Edge Function");
      
      const { data, error } = await supabase.functions.invoke('send-contact-notification', {
        body: formData,
      });
      
      if (error) {
        console.error("Notification error:", error);
        // Don't throw error for notification failure
        return { success: false };
      }
      
      console.log("Notification response:", data);
      return { success: true };
    } catch (error) {
      console.warn("Failed to send notification:", error);
      // Don't throw error for notification failure
      return { success: false };
    }
  }
}

export const contactApi = new ContactApi();
